import React from 'react';
import { Hero } from '../components/home/Hero';
import { ProofBand } from '../components/home/ProofBand';
import { Solutions } from '../components/home/Solutions';
import { TemplateVsCustom } from '../components/home/TemplateVsCustom';
import { AiSeoLanes } from '../components/home/AiSeoLanes';
import { EcommerceFees } from '../components/home/EcommerceFees';
import { SupportLoop } from '../components/home/SupportLoop';
import { PortfolioTeaser } from '../components/home/PortfolioTeaser';
import { GuaranteeBand } from '../components/home/GuaranteeBand';
import { GetStarted } from '../components/home/GetStarted';
import { pageMeta, useDocumentMeta } from '../hooks/useDocumentMeta';
export function Home() {
  useDocumentMeta(pageMeta.home);
  return <>
      <Hero data-id="element-366" data-mp="2dfm7jqxa8872" />
      <ProofBand data-id="element-367" data-mp="3kvadcpw1yhx4" />
      <Solutions data-id="element-368" data-mp="3kvtn3jbju002" />
      <TemplateVsCustom data-id="element-369" data-mp="3ku8s5slbof1o" />
      <AiSeoLanes data-id="element-370" data-mp="3kv0mz173i8qw" />
      <EcommerceFees data-id="element-371" data-mp="3kxmtcxi92i7j" />
      <SupportLoop data-id="element-372" data-mp="3owlwcckf84wc" />
      <PortfolioTeaser data-id="element-373" data-mp="3ow3zpetujonw" />
      <GuaranteeBand data-id="element-374" data-mp="3ovatqg2pp36t" />
      <GetStarted data-id="element-375" data-mp="3oyyk56cv19hb" />
    </>;
}